module.exports = __webpack_public_path__ + "img/equipo_16-9_1920.ca5bf596.jpg";